import { render, staticRenderFns } from "./Produits.vue?vue&type=template&id=2209ef87&"
import script from "./Produits.vue?vue&type=script&lang=js&"
export * from "./Produits.vue?vue&type=script&lang=js&"
import style0 from "./Produits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports